import { Col, Form, Row } from "react-bootstrap";
import ColorInput from "../ColorInput";
import FileInput from "../FileInput";
import ColorPickerAdd from "../ColorPickerAdd";
import ColorPickerClose from "../ColorPickerClose";

const KeysSettings = ({
  formData,
  setFormData,
  onInputChange,
  handleFileChange,
  fileNames,
  files,
  validate,
}) => {
  const gradientOptions = [
    { value: 1, label: "Top to Bottom" },
    { value: 2, label: "Left to Right" },
    { value: 3, label: "Top Left to Bottom Right" },
    { value: 4, label: "Top Right to Bottom Left" },
  ];

  const addBgColor = () => {
    setFormData((prev) => ({
      ...prev,
      keys: {
        ...prev.keys,
        bgColor: [...prev.keys.bgColor, "#000000"],
      },
    }));
  };

  const removeBgColor = (index) => {
    setFormData((prev) => {
      const updatedBgColors = prev.keys.bgColor.filter((_, i) => i !== index);
      return {
        ...prev,
        keys: {
          ...prev.keys,
          bgColor: updatedBgColors,
          bgOrientation:
            updatedBgColors.length === 1 ? null : prev.keys.bgOrientation,
        },
      };
    });
  };

  return (
    <Row className="gy-3">
      <Col md={3}>
        <Form.Group>
          <Form.Label htmlFor="bgType">Background Type</Form.Label>
          <Form.Select
            name={`keys.bgType`}
            value={formData.keys.bgType || "color"}
            onChange={onInputChange}
            className="my-2"
          >
            <option value="color">Color</option>
            <option value="image">Image</option>
          </Form.Select>
        </Form.Group>
      </Col>
      <Col md={3} sm={6}>
        <ColorInput
          label="Text Color"
          name="keys.textColor"
          value={formData.keys.textColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3} sm={6}>
        <ColorInput
          label="Border Color"
          name="keys.borderColor"
          value={formData.keys.borderColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label>Border Width (px)</Form.Label>
          <Form.Control
            type="number"
            name="keys.borderWidth"
            value={formData.keys.borderWidth}
            onChange={onInputChange}
            min={0}
            className="my-2"
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label>Opacity (Ex., 0.5)</Form.Label>
          <Form.Control
            type="text"
            name="keys.opacity"
            value={formData.keys.opacity}
            onChange={onInputChange}
            min={0}
            max={1}
            className="my-2"
          />
        </Form.Group>
      </Col>
      {formData.keys.bgType === "color" && (
        <>
          <Col md={3} sm={12}>
            <div className="d-flex align-items-center gap-4">
              <Form.Label>Background Color</Form.Label>
              <ColorPickerAdd addBgColor={addBgColor} />
            </div>
            <div className="d-flex align-items-center gap-3">
              {formData.keys.bgColor.map((color, index) => (
                <div key={index} className="position-relative">
                  <ColorInput
                    name="keys.bgColor"
                    value={color}
                    data-index={index}
                    onChange={onInputChange}
                  />
                  {formData.keys.bgColor.length > 1 && (
                    <ColorPickerClose
                      removeBgColor={removeBgColor}
                      index={index}
                    />
                  )}
                </div>
              ))}
            </div>
          </Col>
          {formData.keys.bgColor.length > 1 && (
            <Col md={4}>
              <Form.Group>
                <Form.Label htmlFor="keys.bgOrientation">
                  Gradient Orientation
                </Form.Label>
                <Form.Select
                  value={formData.keys.bgOrientation}
                  id="keys.bgOrientation"
                  name="keys.bgOrientation"
                  onChange={onInputChange}
                  className="my-2"
                  required={formData.keys.bgColor.length > 1}
                >
                  <option value="">Select Orientation</option>
                  {gradientOptions.map((orientation) => (
                    <option key={orientation.value} value={orientation.value}>
                      {orientation.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Select any one gradient variant
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          )}
        </>
      )}
      {formData.keys.bgType === "image" && (
        <>
          <Col lg={3} sm={12}>
            <FileInput
              label="Key Background Image"
              name="keysBgImage"
              onChange={handleFileChange}
              required={true}
              fileName={fileNames.keysBgImage}
              accept="image/*"
              isInvalid={validate && !files.keysBgImage}
              feedback="Upload a key background image."
            />
          </Col>
          <Col lg={3} sm={12}>
            <FileInput
              label="Key Background Image for Ipad"
              name="keysIpadBgImage"
              onChange={handleFileChange}
              required={true}
              fileName={fileNames.keysIpadBgImage}
              accept="image/*"
              isInvalid={validate && !files.keysIpadBgImage}
              feedback="Upload a key background image for ipad."
            />
          </Col>
          <Col lg={3} sm={12}>
            <FileInput
              label="Key Background Image (Landscape)"
              name="keysBgImageLandscape"
              onChange={handleFileChange}
              required={true}
              fileName={fileNames.keysBgImageLandscape}
              accept="image/*"
              isInvalid={validate && !files.keysBgImageLandscape}
              feedback="Upload a key background image for landscape."
            />
          </Col>
          <Col lg={3} sm={12}>
            <FileInput
              label="Key Background Image for Ipad (Landscape)"
              name="keysIpadBgImageLandscape"
              onChange={handleFileChange}
              required={true}
              fileName={fileNames.keysIpadBgImageLandscape}
              accept="image/*"
              isInvalid={validate && !files.keysIpadBgImageLandscape}
              feedback="Upload a key background image for ipad landscape."
            />
          </Col>
        </>
      )}
      <Col md={3}>
        <Form.Group>
          <Form.Label>Corner Radius (px)</Form.Label>
          <Form.Control
            type="text"
            name="keys.corners"
            value={formData.keys.corners}
            onChange={onInputChange}
            min={0}
            className="my-2"
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default KeysSettings;
